import { Tag } from '@app/ui/components/Dropdown/components';
import { FC } from 'react';
import { Control, UseFormReturn, useWatch } from 'react-hook-form';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { ModalFormValues } from '@app/components/EnrollModal/EnrollModal';

export type TagTheme = 'primary' | 'secondary' | 'white';

interface Props {

  id?: string;
  value: string;
  control: Control<ModalFormValues>;
  register: UseFormReturn<ModalFormValues>[ 'register' ];
  theme?: TagTheme;
  secondaryTheme?: string;

}

const RadioTag: FC<Props> = ({ id, value, register, control, theme = 'secondary' }) => {

  const time = useWatch({

    control,
    name: 'time',

  });

  const tagId = id || uuidv4();

  return (

    <Root htmlFor = { tagId }>

      <Input { ...register('time') } type = "radio" value = { value } id = { tagId } />

      <Tag

        isLarge
        theme = { time === value ? 'primary' : theme }
        value = { value }
        hasClose = { false }

      />

    </Root>

  );

};

export default RadioTag;

const Root = styled.label`

  cursor: pointer;

`;

const Input = styled.input`

  position: absolute;
  left: 0;
  opacity: 0;

`;
